import { createCpmsBoChannelSlice } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-channel.slice';

import { cpmsBoChannelApi } from './cpms-bo-channel.service';

export const cpmsBoChannelSlice = createCpmsBoChannelSlice({
  cpmsBoChannelApi,
});
